import { IComboSelectBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IComboObjectBean } from "../../../beans/objects";
import { ItemsTranslator } from "./ItemsTranslator";
import { IntegerTranslator, ColorCodeTranslator } from "../../values";

export class ComboSelectBehaviorTranslator {
  from(bean: IComboObjectBean): IComboSelectBehavior {
    return {
      code: bean["@code"],
      options: this.items.from(
        bean.comboitem,
        s => {
          return {
            text: s["@text"],
            isSelected: (s["@selected"] === "1"),
            score: this.integer.from(s["@score"]),
            style: {
              foreground: {
                color: {
                  value: this.colorCode.from(s["@fg"]),
                },
              },
              background: {
                isEnable: (s["@bg"] !== undefined) && (s["@bg"] !== null),
                color: {
                  value: this.colorCode.from(s["@bg"]),
                },
              },
            },
            code: s["@code"],
            movePageBehavior: {
              isEnable: !!s["@jump-link"],
              pageKey: (s["@jump-link"] && s["@jump-link"].match(/^\[page\].+$/)) ? this.integer.from(s["@jump-link"].substring(6)) : null,
            },
          };
        },
      ),
    };
  }

  to(object: IComboSelectBehavior) {
    return {
      code: undefined as string,  // フォーマット編集では設定されないのでundefined固定.
      comboitem: this.items.to(
        object.options,
        s => ({
          "@name": s.isSelected ? "-- 選択 --" : s.text,  // 初回未選択時は空...じゃない模様.
          "@text": s.isSelected ? "" : s.text,            // 初回未選択時は空.
          "@fg": this.colorCode.to(s.style.foreground.color.value),
          "@bg": s.style.background.isEnable ? this.colorCode.to(s.style.background.color.value) : undefined, // nullの場合は出力しない
          "@score": this.integer.to(s.score),
          "@selected": s.isSelected ? "1" : undefined,  // 初回未選択時は出力しない.
          "@code": !!s.code ? s.code : undefined,
          "@jump-link": s.movePageBehavior.isEnable ? ("[page]" + s.movePageBehavior.pageKey) : undefined,
        })
      ),
    };
  }

  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
  private readonly colorCode = new ColorCodeTranslator();
}
